import $ from 'jquery';

class Ad {

	constructor( node ) {
		this.node = node;
		this.$node = $(node);
		this.duration = 7000;
		this.activeClass = 'shortcode-ad--image--rotate--active';
		this.active = 0;

		this.$figures = this.$node.find('> figure');
		this.length = this.$figures.length;
		this.$figures.first().addClass(this.activeClass);
		this.interval = setInterval( this.next.bind(this), this.duration );
	}

	next() {
		this.$figures.eq(this.active).removeClass(this.activeClass);

		if ( this.active < this.length - 1 ) {
			this.active++;
		} else {
			this.active = 0;
		}

		this.$figures.eq(this.active).addClass(this.activeClass);
	}

}

export default Ad;
